import axiosInstance from 'services/common/axiosInstance';

export interface ProductBenefit {
  id: number;
  product_id: number;
  benfit_title: string;
  benfit_description: string;
  status: string;
  created_on: string;
  created_by: string;
  updated_on: string;
  updated_by: string;
}

export interface ProductAdditionalInfo {
  id: number;
  product_id: number;
  policy_term: string;
  premium_term: string;
  minimum_sum_assured: string;
  maximum_sum_assured: string;
  maturity_bonus_benefit: string;
  death_benefit: string;
  loan_facility: string;
  surrender_value: string;
  status: string;
  created_on: string;
  created_by: string;
  updated_on: string;
  updated_by: string;
}

export interface ProductEligibility {
  id: number;
  product_id: number;
  min_age: number;
  max_age: number;
  customer_eligibility: string;
  medical_requirement: string;
  max_maturity_age: number;
  status: string;
  created_on: string;
  created_by: string;
  updated_on: string;
  updated_by: string;
}

export interface ProductPremium {
  id: number;
  product_id: number;
  premium_note: string;
  age: string;
  monthly_bd: number;
  quarterly_bd: number;
  half_yearly_bd: number;
  yearly_bd: number;
  sum_assured: number;
  status: string;
  created_on: string;
  created_by: string;
  updated_on: string;
  updated_by: string;
}

export interface Product {
  id: number;
  product_category: string;
  product_code: string;
  product_name: string;
  product_description: string;
  plan_type: string;
  product_image_url: string;
  status: string;
  created_on: string;
  created_by: string;
  updated_on: string;
  updated_by: string;
  product_benfit: ProductBenefit[];
  product_additional_info: ProductAdditionalInfo;
  product_eligibility: ProductEligibility[];
  product_premium: ProductPremium[];
}

export interface Pagination {
  page: number;
  per_page: number;
  total_pages: number;
  total_items: number;
}

export interface PaginationWeb extends Pagination {
  total_active: number;
  total_inactive: number;
}

export interface ProductListResponse {
  message: string;
  data: {
    product: Product[];
    pagination: Pagination;
  };
  success: boolean;
}

export interface ProductListWebResponse {
  message: string;
  data: {
    product: Product[];
    pagination: PaginationWeb;
  };
  success: boolean;
}

export interface GetProductListParams {
  page: number;
  per_page: number;
  product_code: string;
  product_category: string;
  product_name: string;
}

export const fetchProductListForMobile = async (
  data: GetProductListParams
): Promise<ProductListResponse> => {
  try {
    const response = await axiosInstance.post('/product/getallproducts_for_mobile', data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const fetchProductListForWeb = async (
  data: GetProductListParams
): Promise<ProductListWebResponse> => {
  try {
    const response = await axiosInstance.post('/product/getallproductsforweb', data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

